import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { LogoLockup } from "@/components/dw/Logo";
import { Input } from "@/components/ui/input";

export default function AppLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If already logged in, redirect to /app
    api.get("/app/me").then(() => nav("/app")).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome!");
      nav("/app");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Sign in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10" style={{ background: "var(--bg-paper)" }}>
      <div className="w-full max-w-sm">
        <div className="flex justify-center">
          <LogoLockup size={64} />
        </div>
        <div className="mt-8 card-soft p-8">
          <h1 className="font-display text-3xl" style={{ color: "var(--primary)" }}>Sign in</h1>
          <p className="mt-1 text-sm" style={{ color: "var(--text-secondary)" }}>Enter your DietWalaa credentials.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-[10px] uppercase tracking-widest font-bold" style={{ color: "var(--text-secondary)" }}>Email</label>
              <Input data-testid="app-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-widest font-bold" style={{ color: "var(--text-secondary)" }}>Password</label>
              <Input data-testid="app-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 rounded-xl" />
            </div>
            <button data-testid="app-login-submit" disabled={loading} className="btn-primary w-full h-12 disabled:opacity-60">
              {loading ? "…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6 text-center text-xs" style={{ color: "var(--text-secondary)" }}>
            Don&rsquo;t have an account? Contact your dietitian.
          </div>
        </div>
      </div>
    </div>
  );
}
